export * from './replace.directive';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/directives/replace/index.ts